import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  height: 264px;
`;

export const MapBottomAddress = styled.div`
  width: 100%;
  padding: 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.hotelDetails.bottomAddress};
  background-color: ${({ theme }) => theme.hotelDetails.bookingInfo};
  height: 58px;
  display: block;
`;

export const Dot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.hotelsList.mapPinBackground};
`;
